import React, { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Button,
  Card,
  CircularProgress,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import moment from "moment";
import { Delete, ExpandMore, Person, RemoveRedEyeOutlined, Schedule } from "@material-ui/icons";
import { blue } from "@material-ui/core/colors";
import { Autocomplete } from "@material-ui/lab";

const RefreshmentGroupcard = ({ w, r, index, firebase, formId, setProfileOpen, setUserData, openProfile, uidForEmail }) => {
  const [selectedRescuer, setSelectedRescuer] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [removilgList, setRemovilgList] = useState([]);

  //console.log("identificadior del formulario", formId);
  const addVolunteer = () => {
    setIsLoading(true);
    /* r.forEach((r) => {
      if (r.uid == selectedRescuer) {
        em = r.email;
        nam = r.name;
      }
    });*/
    firebase
      .user(selectedRescuer.uid)
      .child(`sgpfc/onSiteTrainings/forms/${formId}/selectedSchedule`)
      .update({
        email: selectedRescuer.email,
        id: index,
        name: selectedRescuer.name,
        text: moment(w.time).format("dddd DD MMM · HH:mm"),
      })
      .then(() => {
        firebase
          .user(selectedRescuer.uid)
          .child(`sgpfc/onSiteTrainings/next`)
          .update({
            id: formId,
            time: w.time,
          })
          .then(() => {
            setTimeout(() => {
              setIsLoading(false);
              setSelectedRescuer(null);
            }, 2000);
          });
      });

    console.log({
      email: selectedRescuer.email,
      text: moment(w.time).format("dddd DD MMM · HH:mm"),
      id: index,
      name: selectedRescuer.name,
      key: formId,
      uid: selectedRescuer,
    });
  };

  const handleChange = (e, newValue) => {
    setSelectedRescuer(newValue);
    //setSelectedRescuer(e.target.value);
  };

  const removeVolunteerFromCourse = (uid, i) => {
    let aux = removilgList;
    aux.push(i);
    setRemovilgList(aux);
    firebase
      .user(uid)
      .child(`sgpfc/onSiteTrainings/forms/${formId}/selectedSchedule`)
      .remove()
      .then(() => {
        setTimeout(() => {
          aux = removilgList;
          console.log("auxiliar", aux);
          console.log("posición del eliminado", aux.indexOf(i));
          aux.splice(aux.indexOf(i), 1);
          console.log("despues de eliminar", aux);
          setRemovilgList(aux.map((a) => a));
        }, 250);
      });
  };

  const handleOpenProfile = (uid) => {
    openProfile(true);
    uidForEmail(uid);
  };

  return (
    <Grid item xs={12}>
      <Card variant="outlined" style={{ padding: 16, borderRadius: 16, backgroundColor: blue[50] }}>
        <Grid item xs={12} style={{ paddingRight: 0, paddingLeft: 0 }}>
          <Accordion elevation={0} style={{ backgroundColor: blue[50] }}>
            <AccordionSummary expandIcon={<RemoveRedEyeOutlined />} aria-controls="panel1a-content" id="panel1a-header">
              <Grid container alignItems="center" spacing={2}>
                <Grid item xs={12} md={5}>
                  <Typography variant="h6" color="primary">
                    {moment(w.time).format("dddd DD MMM · HH:mm")}
                  </Typography>
                  <Typography>
                    Plazas restantes {w.remaining} de {w.capacity}
                  </Typography>
                </Grid>
                <Grid item xs={12} lg={4} onClick={(event) => event.stopPropagation()} container>
                  <Autocomplete
                    options={Array.isArray(r) ? r : []}
                    fullWidth
                    size="small"
                    value={selectedRescuer}
                    getOptionLabel={(option) => option?.email || ""}
                    onChange={handleChange}
                    loading={!Array.isArray(r) || r.length === 0}
                    loadingText="Cargando voluntarios..."
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Añadir voluntario"
                        variant="outlined"
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {(!Array.isArray(r) || r.length === 0) && <CircularProgress color="inherit" size={20} />}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={2} onClick={(event) => event.stopPropagation()}>
                  <Button variant="contained" color="primary" onClick={addVolunteer} disabled={!!!selectedRescuer || isLoading}>
                    Añadir
                    {isLoading && (
                      <CircularProgress
                        size={24}
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          marginTop: -12,
                          marginLeft: -12,
                        }}
                      />
                    )}
                  </Button>
                </Grid>
              </Grid>
            </AccordionSummary>
            <AccordionDetails>
              {
                <List style={{ width: "100%" }}>
                  {w.rescuers ? (
                    w.rescuers.map((r, i) => (
                      <ListItem
                        key={i}
                        alignItems="flex-start"
                        /* onClick={() => {
                          setProfileOpen(true);
                          setUserData({ ...r });
                        }}*/
                        style={{ width: "100%" }}
                      >
                        <ListItemAvatar>
                          <Avatar>{r?.name?.substring(0, 1)?.toUpperCase()}</Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={r.name}
                          secondary={
                            <React.Fragment>
                              <Typography component="span" variant="body2" color="textPrimary">
                                {r.email}
                              </Typography>
                              {` · ${moment(r.logTime).format("DD/MM/YYYY · HH:mm")}`}
                            </React.Fragment>
                          }
                        />
                        <ListItemSecondaryAction>
                          <IconButton
                            edge="end"
                            size="small"
                            onClick={() => {
                              setProfileOpen(true);
                              setUserData({ ...r });
                            }}
                          >
                            <Schedule />
                          </IconButton>
                          <IconButton
                            edge="end"
                            size="small"
                            onClick={() => {
                              handleOpenProfile(r.uid);
                            }}
                          >
                            <Person />
                          </IconButton>
                          <IconButton
                            edge="end"
                            aria-label="delete"
                            size="small"
                            disabled={removilgList.includes(i)}
                            onClick={() => {
                              removeVolunteerFromCourse(r.uid, i);
                            }}
                          >
                            <Delete color={!removilgList.includes(i) ? "error" : "disabled"} />
                            {removilgList.includes(i) && (
                              <CircularProgress
                                size={24}
                                style={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  marginTop: -12,
                                  marginLeft: -12,
                                }}
                              />
                            )}
                          </IconButton>
                        </ListItemSecondaryAction>
                        <Divider variant="inset" />
                      </ListItem>
                    ))
                  ) : (
                    <Typography> :( No hay voluntarios registrados</Typography>
                  )}
                </List>
              }
            </AccordionDetails>
          </Accordion>
        </Grid>
      </Card>
    </Grid>
  );
};

export default RefreshmentGroupcard;
